import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { UserReference } from '@recruitee/account-types';
import type { Candidate, CandidateRating } from '@recruitee/candidate-types';
import { HttpApiService } from '@recruitee/http';
import type { OfferBriefReference } from '@recruitee/offers-types';
import type { StageReference } from '@recruitee/stages-types';

export interface CandidateCollectionParams {
  limit?: string;
  offset?: string;
  disqualified?: boolean;
  ids?: string;
  offerId?: number | null;
  qualified?: boolean;
  query?: string;
  sort?: string;
  sourced?: boolean;
  deleted?: boolean;
}

export type CandidateReferences = OfferBriefReference | StageReference | UserReference;

export interface CandidatesResponse {
  candidates: Candidate[];
  references: CandidateReferences[];
}

@Injectable({ providedIn: 'root' })
export class CandidateHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadCollection(params: CandidateCollectionParams): Observable<CandidatesResponse> {
    return this.httpApi.get('/candidates', params);
  }

  public fetchCandidateRating(candidateId: number): Observable<CandidateRating> {
    return this.httpApi
      .get<{ candidate: CandidateRating }>(`/candidates/${candidateId}/rating`)
      .pipe(map(res => res.candidate));
  }
}
